import { SimpleOrgMember } from '@euler/model/SimpleOrgMember';
import { StoreService } from '@euler/services/store.service';

/** The captured store's members, so grants carry the names it returned. */
export const kBiUploadFixtureMembers: SimpleOrgMember[] = [
  { id: 3855, name: '袁宁松', role: 'manager', jobTitle: '店长' },
  { id: 3856, name: '钟三霞', role: 'serviceAgent', jobTitle: '服务顾问' },
  { id: 3857, name: '何君', role: 'serviceAgent', jobTitle: '服务顾问' },
  { id: 3858, name: '胡皓', role: 'technician', jobTitle: '技师' },
  { id: 3859, name: '郭杰', role: 'technician', jobTitle: '技师' },
];

/** The store's members for the dataset sharing panel, without a server. */
export class FixtureUploadStoreService extends StoreService {
  constructor() {
    super(null as never);
  }
  async getSimpleMemberList(): Promise<SimpleOrgMember[]> {
    return kBiUploadFixtureMembers;
  }
}
